import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    const {light, dark} = this.element.dataset
    const theme = document.documentElement.getAttribute('theme')
    const scheme = window.matchMedia('(prefers-color-scheme: dark)').matches

    this.element.src =
      theme === 'dark' ? dark :
      theme === 'light' ? light :
      scheme ? dark : light
  }
}
